import { Sharer } from "../";
import SharerPropsMixin from "./SharerPropsMixin";

const wlinks = {
  vk: "https://vk.com/share.php?url={link}",
  ok: "https://connect.ok.ru/offer?url={link}",
  fb: "https://www.facebook.com/sharer/sharer.php?u={link}&hashtag={hashtag}",
  tw: "https://twitter.com/intent/tweet?url={link}&text={text}",
  tg: "https://t.me/share/url?url={link}&text={text}"
};

export default {
  name: "Sharer",
  mixins: [SharerPropsMixin],
  computed: {
    linkForShare() {
      return encodeURIComponent(`${this.link}`);
    },
    textForShare() {
      return encodeURIComponent(`${this.text}`);
    }
  },

  methods: {
    linkFor(v) {
      return !wlinks[v]
        ? ""
        : wlinks[v]
            .replace("{link}", this.linkForShare)
            .replace("{text}", this.textForShare)
            .replace("{hashtag}", encodeURIComponent(this.hashtag));
    },
    goalFor(v) {
      return !wlinks[v] ? "" : this.goals.replace("{prefix}", v);
    },
    bindWindowOpener() {
      this.$el.addEventListener("click", e => {
        if (!e.target.closest) {
          //return console.warn(
          //  "This element not supports `closest`. Use polyfill."
          //);
        }
        e.preventDefault();

        let el = e.target.closest('a[target="_blank"]');
        if (!el || !el.hasAttribute("href")) {
          return;
        }

        this.openWindow(el.getAttribute("href"));
      });
    },
    openWindow(href) {
      let w = 626,
        h = 436,
        pos = Sharer.getPositions(w, h);

      let newWindow = window.open(
        href,
        "Share Dialog",
        `width=${w}, height=${h}, top=${pos.top}, left=${pos.left}`
      );

      if (window.focus) {
        newWindow.focus();
      }
    }
  },

  mounted() {
    this.bindWindowOpener();
  }
};
